// Space-owned reference data (floor levels, format views, exposure sizes). Cross-domain
// advertising reference data (placementAreas/supportNames/materialTypes) lives in
// shared/constants — consumers import those directly, not through this feature.
export const floorLevels = [
  { label: 'Level -7', value: 'UNDERGROUND_7' },
  { label: 'Level -6', value: 'UNDERGROUND_6' },
  { label: 'Level -5', value: 'UNDERGROUND_5' },
  { label: 'Level -4', value: 'UNDERGROUND_4' },
  { label: 'Level -3', value: 'UNDERGROUND_3' },
  { label: 'Level -2', value: 'UNDERGROUND_2' },
  { label: 'Level -1', value: 'UNDERGROUND_1' },
  { label: 'Ground Floor', value: 'GROUND_FLOOR' },
  { label: '1st Floor', value: 'FIRST_FLOOR' },
  { label: '2nd Floor', value: 'SECOND_FLOOR' },
  { label: '3rd Floor', value: 'THIRD_FLOOR' },
  { label: '4th Floor', value: 'FOURTH_FLOOR' },
  { label: '5th Floor', value: 'FIFTH_FLOOR' },
  { label: '6th Floor', value: 'SIXTH_FLOOR' },
  { label: 'Multilevel', value: 'MULTILEVEL' },
  { label: 'Terrace', value: 'TERRACE' },
];

export const formatViews = [
  { label: 'Portrait', value: 'PORTRAIT' },
  { label: 'Landscape', value: 'LANDSCAPE' },
  { label: 'Special', value: 'SPECIAL' },
];

export const exposureSizes = [
  { label: 'Standard', value: 'STANDARD_EXPOSURE' },
  { label: 'Large', value: 'LARGE_EXPOSURE' },
];
